import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';
import {
  getAdminV1StoresStoreIdReturns,
  getAdminV1StoresStoreIdReturnsId,
  patchAdminV1StoresStoreIdReturnsId,
  postAdminV1StoresStoreIdOrdersIdReturns,
  postAdminV1StoresStoreIdReturnsIdResolve,
  type GetAdminV1StoresStoreIdReturns200,
  type PatchAdminV1StoresStoreIdReturnsIdBody,
  type PostAdminV1StoresStoreIdOrdersIdReturnsBody,
  type PostAdminV1StoresStoreIdReturnsIdResolveBody,
  type ReturnDetail,
  type ReturnResolved,
} from '@nucleus-commerce/api-client/admin';

/**
 * List params as `listParams` builds them from the route's search: `q`, `sort`, the flat filter
 * params (`status=approved,received`, `requestedAt_gte=2026-09-01`), `cursor`, `limit`.
 */
export type ReturnListParams = ListParams;

/** Returns of one store. The store-credit code exists in the resolve response only. */
export const returnsApi = {
  list: (storeId: string, params: ReturnListParams): Promise<GetAdminV1StoresStoreIdReturns200> =>
    getAdminV1StoresStoreIdReturns({ storeId }, params),
  get: (storeId: string, id: string): Promise<ReturnDetail> =>
    getAdminV1StoresStoreIdReturnsId({ storeId, id }),
  open: (
    storeId: string,
    orderId: string,
    body: PostAdminV1StoresStoreIdOrdersIdReturnsBody,
  ): Promise<ReturnDetail> =>
    postAdminV1StoresStoreIdOrdersIdReturns({ storeId, id: orderId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdReturnsIdBody,
  ): Promise<ReturnDetail> => patchAdminV1StoresStoreIdReturnsId({ storeId, id }, body),
  resolve: (
    storeId: string,
    id: string,
    body: PostAdminV1StoresStoreIdReturnsIdResolveBody,
  ): Promise<ReturnResolved> => postAdminV1StoresStoreIdReturnsIdResolve({ storeId, id }, body),
};
